const STORAGE_KEY = "subscription-ui";

const normalizePath = (pathname) => {
  const base = process.env.PUBLIC_URL || "";
  let path = pathname || "/";
  if (base && path.startsWith(base)) {
    path = path.slice(base.length) || "/";
  }
  return path;
};

export const isSubscriptionRoute = (pathname) => {
  const path = normalizePath(pathname);
  return path === "/subscription" || path.startsWith("/subscription/");
};

export const loadSubscriptionPersistence = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveSubscriptionPersistence = (data) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.warn("Failed to persist subscription state", error);
  }
};

export const getPersistedSubscriptionUiState = () => {
  const data = loadSubscriptionPersistence();
  if (!data) {
    return {
      hasCache: false,
      selectedProductId: null,
      products: [],
      selectedProduct: null
    };
  }

  const products = Array.isArray(data.products) ? data.products : [];
  const selectedProductId = data.selectedProductId ?? null;
  const normalizedSelectedId =
    selectedProductId == null || selectedProductId === ""
      ? null
      : String(selectedProductId);
  const selectedProduct =
    normalizedSelectedId != null
      ? products.find((product) => String(product.id) === normalizedSelectedId) || null
      : null;

  return {
    hasCache: Boolean(products.length > 0 || selectedProductId != null),
    selectedProductId,
    products,
    selectedProduct
  };
};
